import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpgradeModule } from '@angular/upgrade/static';
import { NgrxFormsModule } from 'ngrx-forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { SafePipeModule } from 'safe-pipe';
import { CleanVariableAfterPasteDirective } from '../core/clean-after-paste/clean-variable-after-paste.directive';
import { ContenteditableDirective } from '../core/content-editable/contenteditable.directive';
import { FeatureFlagsModule } from '../feature-flag/feature-flag.module';
import { NgEditorModule } from '../ng-editor/ng-editor.module';
import { PowernovaValueComponent } from '../powernova/powernova-value/powernova-value.component';
import { PowernovaComponent } from '../powernova/powernova.component';
import { PreviewEditTemplateService } from '../preview-edit-template/state/preview-edit-template.service';
import { AudioService } from '../services/audio.service';
import { TemplateParametersComponent } from '../template-parameters/template-parameters.component';
import { TwilioVoiceParameterComponent } from '../twilio-voice/twilio-voice-parameter/twilio-voice-parameter.component';
import { TwilioVoiceComponent } from '../twilio-voice/twilio-voice.component';
import { UploadImageDirective } from '../upload-images/upload-image.directive';
import { EmailMessageNewComponent } from './email-message-new.component';
import { MessagesComponent } from './messages.component';
import { SmsConversionComponent } from './sms-convertion-ar2-to-ar3/sms-conversion.component';
import { SmsConversionService } from './sms-convertion-ar2-to-ar3/sms-conversion.service';
import { TagMappingModalComponent } from './sms-convertion-ar2-to-ar3/tags-mapping-modal/tag-mapping-modal.component';
import { SmsMessageNewComponent } from './sms-message-new.component';
import { VoiceMessageNewComponent } from './voice-message-new.component';

@NgModule({
  imports: [
    CommonModule,
    TabViewModule,
    DropdownModule,
    UpgradeModule,
    FormsModule,
    NgrxFormsModule,
    ReactiveFormsModule,
    TooltipModule,
    TableModule,
    SafePipeModule,
    NgEditorModule,
    FeatureFlagsModule
  ],
  declarations: [
    MessagesComponent,
    SmsMessageNewComponent,
    EmailMessageNewComponent,
    VoiceMessageNewComponent,
    TemplateParametersComponent,
    ContenteditableDirective,
    CleanVariableAfterPasteDirective,
    UploadImageDirective,
    PowernovaComponent,
    PowernovaValueComponent,
    TwilioVoiceComponent,
    TwilioVoiceParameterComponent,
    TagMappingModalComponent,
    SmsConversionComponent
  ],
  providers: [PreviewEditTemplateService, AudioService],
  exports: [
    MessagesComponent,
    TemplateParametersComponent,
    ContenteditableDirective,
    UploadImageDirective
  ]
})
export class MessagesModule {}
